module.exports = __webpack_public_path__ + "img/banner-voices.e91bf177.png";